export const ADMIN_SPACE_SETTINGS_PATH = '/admin/space/settings';
export const ADMIN_SPACE_SETTINGS_FILES_PATH = '/admin/space/settings/files';
export const ADMIN_SPACE_SETTINGS_USERS_PATH = '/admin/space/settings/users';
export const ADMIN_SPACE_SETTINGS_EMAILS_PATH = '/admin/space/settings/emails';
export const ADMIN_SPACE_SETTINGS_USERS_ADD_PATH = '/admin/space/settings/users/add';
export const ADMIN_SPACE_SETTINGS_USERS_EDIT_PATH = '/admin/space/settings/users/:userId/edit';
